<script lang="ts">
  import { auth } from "$lib/stores/auth.svelte";
  import { navigate } from "$lib/router.svelte";

  let { children } = $props();

  $effect(() => {
    if (!auth.loading && !auth.user) {
      navigate("/login", { replace: true });
    }
  });
</script>

{#if auth.loading}
  <div class="flex h-screen items-center justify-center">
    <div class="text-slate-500">Carregando…</div>
  </div>
{:else if auth.user}
  {@render children()}
{/if}
